const DashboardPage = () => {
    return(
        <></>
    );
}

export default DashboardPage;